import { BasicResult } from "../basic-result";
import { Campaign } from "./campaign";

export class CampaignReturn extends BasicResult{
    public Request:Campaign = new Campaign();
    constructor(values: Object = {}){
        super();
         Object.assign(this, values);  
         
    } 
}